import { MenuItem, TextField, TextFieldProps } from "@mui/material";

import { MapEditorObservationPanelObservationTypeFragment } from "./fragments.generated";

type Props = {
    disabled: boolean;
    label: string;
    options: MapEditorObservationPanelObservationTypeFragment[];
    value: string;
    onChange?: (value: string) => void;
    error?: boolean;
    helperText?: string;
};

export function ObservationTypeSelect({ label, value, onChange, options, disabled, error, helperText }: Props) {
    const handleOnChange: TextFieldProps["onChange"] = event => {
        const nextValue = event.target.value;
        onChange?.(nextValue);
    };

    return (
        <TextField
            select
            disabled={disabled}
            label={label}
            value={value}
            onChange={handleOnChange}
            error={error}
            helperText={helperText}
        >
            {options.map(element => (
                <MenuItem key={element.id} value={element.id} selected={element.id === value}>
                    {element.name}
                </MenuItem>
            ))}
        </TextField>
    );
}
